/* eslint no-bitwise: ["error", { "allow": ["|","&"] }] */

export function getUUID() {
  var len = 8;
  var radix = typeof window.radix === 'undefined' ? 16 : window.radix;
  var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  var uuid = [];
  var i;
  radix = radix || chars.length;
  if (len) {
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix];
  } else {
    var r;
    uuid[8] = '-';
    uuid[13] = '-';
    uuid[18] = '-';
    uuid[23] = '-';
    uuid[14] = '4';
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16;
        uuid[i] = chars[i == 19 ? r & 0x3 | 0x8 : r];
      }
    }
  }
  return uuid.join('');
}
export function getCurrentTime() {
  var time = new Date();
  return "[" + time.getFullYear() + "/" + (time.getMonth() + 1) + "/" + time.getDate() + " " + time.getHours() + ":" + time.getMinutes() + ":" + time.getSeconds() + ":" + time.getMilliseconds() + "]";
}
export function getUserInfo() {
  var _window$headerGlobalD, _window$headerGlobalD2, _window$headerGlobalD3, _window$headerGlobalD4, _window$headerGlobalD5, _window$headerGlobalD6;
  var userInfo = ((_window$headerGlobalD = window.headerGlobalData) === null || _window$headerGlobalD === void 0 ? void 0 : (_window$headerGlobalD2 = _window$headerGlobalD.getData) === null || _window$headerGlobalD2 === void 0 ? void 0 : _window$headerGlobalD2.call(_window$headerGlobalD, 'userInfo')) || {};
  return {
    accountNo: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.accountName) || '',
    accountName: (userInfo === null || userInfo === void 0 ? void 0 : userInfo.userName) || '',
    resCode: ((_window$headerGlobalD3 = window.headerGlobalData) === null || _window$headerGlobalD3 === void 0 ? void 0 : (_window$headerGlobalD4 = _window$headerGlobalD3.getData) === null || _window$headerGlobalD4 === void 0 ? void 0 : _window$headerGlobalD4.call(_window$headerGlobalD3, 'warehouseId')) || '',
    resName: ((_window$headerGlobalD5 = window.headerGlobalData) === null || _window$headerGlobalD5 === void 0 ? void 0 : (_window$headerGlobalD6 = _window$headerGlobalD5.getData) === null || _window$headerGlobalD6 === void 0 ? void 0 : _window$headerGlobalD6.call(_window$headerGlobalD5, 'warehouseName')) || ''
  };
}